export default __webpack_public_path__ + "48d14272108d91e1a0f480540ab4ee6f.svg";